@use "/src/styles/functions.scss";

.line {
  flex: 0 0 auto;

  &[data-dir="horizontal"] {
    height: 1px;
    width: 100%;
    border-top: 1px solid functions.getThemeColor(stroke-soft-200);
  }
  &[data-dir="vertical"] {
    height: 100%;
    width: 1px;
    border-left: 1px solid functions.getThemeColor(stroke-soft-200);
  }
}
.lineSpacing {
  padding: 1.5px 0 1.5px 0;
}
.text {
  padding: functions.toRem(4) functions.toRem(8) functions.toRem(4)
    functions.toRem(8);
}
.solidText {
  background-color: functions.getThemeColor(stroke-soft-200);
  padding: functions.toRem(6) functions.toRem(20) functions.toRem(6)
    functions.toRem(20);
}

.textDivider {
  display: flex;
  align-items: center;
  gap: functions.space(10);
}

.grow {
  flex-grow: 1;
  width: unset !important;
}
